/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventscalendarnextmonth3Inputs */

const en_eventscalendarnextmonth3 = /** @type {(inputs: Eventscalendarnextmonth3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next month`)
};

const de_eventscalendarnextmonth3 = /** @type {(inputs: Eventscalendarnextmonth3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächster Monat`)
};

/**
* | output |
* | --- |
* | "Next month" |
*
* @param {Eventscalendarnextmonth3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventscalendarnextmonth3 = /** @type {((inputs?: Eventscalendarnextmonth3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventscalendarnextmonth3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventscalendarnextmonth3(inputs)
	return de_eventscalendarnextmonth3(inputs)
});
export { eventscalendarnextmonth3 as "eventsCalendarNextMonth" }